import { createFileRoute } from "@tanstack/react-router"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { useDocumentTitle } from "@/lib/useDocumentTitle"

const contactData = {
  mobileNr: "0170 4700820",
  telephoneNr: "05741 298338",
  name: "Martin Kupski",
  email: "martin@pianoservice-kupski.de",
  street: "Bergkämpe",
  houseNr: "6",
  city: "32312 Lübbecke",
}

export const Route = createFileRoute("/kontakt")({
  component: KontaktPage,
})

function KontaktPage() {
  useDocumentTitle("Kontakt - Pianoservice Kupski")
  const { telephoneNr, mobileNr, name, email, street, houseNr, city } =
    contactData

  return (
    <div className="flex flex-col flex-1 items-center justify-center py-8 px-4">
      <Card className="w-full max-w-lg">
        <CardHeader>
          <CardTitle className="font-serif text-primary text-3xl">
            Kontakt
          </CardTitle>
        </CardHeader>
        <CardContent className="prose dark:prose-invert">
          <p>
            <b>Anschrift:</b>
            <br />
            <a
              href={`http://maps.google.com/?q=Piano Service ${street} ${houseNr},${city}`}
              className="hover:text-primary transition-colors"
            >
              {name}
              <br />
              {street && street + " " + houseNr}
              <br />
              {city}
            </a>
          </p>
          <p>
            <b>Telefon:</b>
            <br />
            <a
              href={`tel:${telephoneNr}`}
              className="hover:text-primary transition-colors"
            >
              {telephoneNr}
            </a>
          </p>
          <p>
            <b>Mobil:</b>
            <br />
            <a
              href={`tel:${mobileNr}`}
              className="hover:text-primary transition-colors"
            >
              {mobileNr}
            </a>
          </p>
          <p>
            <b>E-Mail:</b>
            <br />
            <a
              href={`mailto:${email}`}
              className="hover:text-primary transition-colors"
            >
              {email}
            </a>
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
